// extracted by mini-css-extract-plugin
module.exports = {"content":"Awards-module--content--1AYCn","awards":"Awards-module--awards--2iJTE","awards__logo":"Awards-module--awards__logo--1s0kL"};